import {autobind} from 'core-decorators';

import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars
import type {FormEvent} from 'inferno';

import {Link, Page} from '../../common/components';
import {Metadata} from '../../common/metadata';


import './developer.scss';


export class DevPage extends Page {
    loggedIn?: boolean;

    pageInit(props: jsx.Props, state: jsx.State) {
        this.loggedIn = this.context.authService.isLoggedIn();
        if (this.loggedIn) {
            this.authedPageInit(props, state);
        }
    }
    authedPageInit(props: jsx.Props, state: jsx.State) {}
    pageChanged(props: jsx.Props, state: jsx.State) {
        return this.loggedIn !== this.context.authService.isLoggedIn();
    }

    unauthedRenderPage() {
        return (
            <div className="DevActivationPage page">
                <Metadata page={this} />
                <h1>Please Log in to Complete Activation</h1>
            </div>
        );
    }

    authedRenderPage() {
        return <div/>;
    }

    @autobind
    openAuthDialogIfLoggedOut(event?: FormEvent<HTMLInputElement>) {
        this.loggedIn = this.context.authService.isLoggedIn();
        if (!this.loggedIn) {
            event?.target.blur();
            this.context.authService.showLoginDialog();
        }
    }

    renderPage() {
        if (this.context.authService.isLoggedIn()) {
            return this.authedRenderPage();
        } else {
            return this.unauthedRenderPage();
        }
    }
}

export class KeyRegistrationPage extends DevPage {
    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
        this.state = {
            ...this.state,
            appname: '',
            appdesc: '',
            reference: '',
        };
    }

    @autobind
    handlePageDone() {
        super.handlePageDone();
        process.env.BROWSER && this.openAuthDialogIfLoggedOut();
    }

    authedPageInit(props: jsx.Props) {
        this.title = 'Tenor GIF Keyboard - Bring Personality To Your Conversations';
        this.description = 'Say more with Tenor. Find the perfect Animated GIFs and videos to convey exactly what you mean in every conversation.';
    }

    unauthedRenderPage() {
        return this.authedRenderPage();
    }

    authedRenderPage() {
        return (
            <div className="KeyRegistrationPage page">
                <Metadata page={this} />
                <h1>API Key Registration</h1>
                <p>V1 API Key registration is no longer supported.</p>
            </div>
        );
    }
}

export class DevDashboardPage extends DevPage {
    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
        this.state = {
            ...this.state,
            keysActive: false,
            apps: [],
            email: '',
            emailSent: false,
        };
    }
    @autobind
    handlePageDone() {
        super.handlePageDone();
        process.env.BROWSER && this.openAuthDialogIfLoggedOut();
    }

    authedPageInit(props: jsx.Props, state: jsx.State) {
        state.keysActive = false;
        state.apps = [];
        state.email = '';
        state.emailSent = false;
        this.title = 'Tenor GIF Keyboard - Bring Personality To Your Conversations';
        this.description = 'Say more with Tenor. Find the perfect Animated GIFs and videos to convey exactly what you mean in every conversation.';
        this.getDevProfile();
    }

    @autobind
    done({body}) {
        this.setState({
            keysActive: body.keys_active,
            apps: body.apps,
            email: body.email,
        });
    }

    @autobind
    err(error) {
        this.context.request.console.error(error);
    }

    @autobind
    getDevProfile() {
        process.env.BROWSER && this.context.apiService.getDevProfile(
            this.context.authService.getLegacyToken())
            .then(this.done, this.err);
    }

    @autobind
    resendCallback({body}) {
        if (body?.result) {
            this.setState({emailSent: true});
        }
    }

    @autobind
    resendEmail() {
        this.context.apiService.sendActivationEmail(
            this.context.authService.getLegacyToken())
            .then(this.resendCallback, this.err);
    }

    authedRenderPage() {
        return (
            <div className="DevDashboardPage container page">
                <Metadata page={this} />
                <h1>Developer Dashboard</h1>
                <label>Your Account:</label>
                <table>
                    <tr>
                        <td>{this.state.email}</td>
                        <td>{(() => {
                            if (this.state.keysActive) {
                                return <span>Verified (Your API Keys are ready
                                    to be used)</span>;
                            }
                            if (this.state.emailSent) {
                                return <span>Not Verified (The verification
                                    email has been sent to your email address.
                                    Please verify within 24 hours)</span>;
                            }
                            return <span>Not Verified
                                (<a onClick={this.resendEmail}>click here</a>
                                    to resend email)</span>;
                        })()}</td>
                    </tr>
                </table>
                <label>Your Apps:</label>
                <table>
                    <tr>
                        <th>NAME</th>
                        <th>KEY</th>
                    </tr>
                    {this.state.apps.map((app, i) => {
                        return (
                            <tr key={i}>
                                <td>{app.appname}</td>
                                <td>{app.apikey}</td>
                            </tr>
                        );
                    })}
                </table>
                <br />
                <div>
                    To create additional API keys, please navigate to our
                    <Link
                        to="https://developers.google.com/tenor/guides/quickstart"
                    >V2 API Documentation</Link>.
                </div>
            </div>
        );
    }
}

export class DevActivationPage extends DevPage {
    token?: string;

    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
        this.state = {
            ...this.state,
            loading: true,
            activated: false,
        };
    }
    authedPageInit(props: jsx.Props) {
        this.title = 'Tenor GIF Keyboard - Bring Personality To Your Conversations';
        this.description = 'Say more with Tenor. Find the perfect Animated GIFs and videos to convey exactly what you mean in every conversation.';

        const query = new URLSearchParams(
            this.context.router.history.location.search);
        this.token = query.get('keytoken');
        this.setState({
            loading: true,
            activated: false,
        });
        this.apikeyActivate();
    }

    @autobind
    handlePageDone() {
        super.handlePageDone();
        process.env.BROWSER && this.openAuthDialogIfLoggedOut();
    }

    @autobind
    done({body}) {
        this.setState({
            activated: body.activation_result,
            loading: false,
        });
    }

    @autobind
    err(error) {
        this.context.request.console.error(error);
        this.setState({
            loading: false,
        });
    }

    @autobind
    apikeyActivate() {
        this.context.apiService.apikeyActivate(this.token)
            .then(this.done, this.err);
    }

    authedRenderPage() {
        let content;
        if (this.state.loading) {
            content = <h1>Activating...</h1>;
        } else if (this.state.activated) {
            content = [
                <h1>‎✔ Your account is verified!</h1>,
                <img
                    src="https://media.tenor.com/images/4c3b395bb7e3b40b780ac97f287b6ab3/tenor.gif"
                />,
                <Link
                    to="/developer/dashboard"
                ><div className="button">View Your API Keys</div></Link>,
            ];
        } else {
            content = <h1>Unable to Activate</h1>;
        }
        return (
            <div className="DevActivationPage page">
                <Metadata page={this} />
                { content }
            </div>
        );
    }

    unauthedRenderPage() {
        return (
            <div className="DevActivationPage page">
                <Metadata page={this} />
                <h1>Please Log in to Complete Activation</h1>
            </div>
        );
    }
}
